import { queryOptions } from '@tanstack/react-query';

import { IRequestMaterialStage } from '@entities/requestMaterial/model/types';

import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { getPositionList } from '@entities/requestMaterial/api/api-funcs';

export const requestMaterialApi = {
    getPositionListQueryOptions: () =>
        queryOptions({
            queryKey: ['estimateSupplyRequestPositionList'],
            queryFn: ({ signal }) => getPositionList({ signal }),
            select: (response) => keysToCamel<IRequestMaterialStage[]>(response.data?.data),
            staleTime: 0,
        }),
};
